import type { FeatureEntitlements, User } from '../types/api'

const DENIED: FeatureEntitlements = {
  workoutMode: false,
  workoutHistory: false,
  proView: false,
  clientWorkoutHistory: false,
  autoProlongation: false,
  createOwnBlocksAndPrograms: false,
  canAddTrainee: false,
  hasActiveCoach: false,
}

export function entitlementsOf(user: User | null | undefined): FeatureEntitlements {
  return user?.entitlements ?? DENIED
}

export function isCoachedTrainee(user: User | null | undefined): boolean {
  return entitlementsOf(user).hasActiveCoach && !user?.hasTrainees
}
